"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendData;

function sendData(url, data) {
  if (typeof window === 'undefined') {
    return {
      "catch": function _catch() {}
    };
  }

  if (typeof window.fetch === 'function') {
    return postData(url, data);
  }

  var errorHandler = function errorHandler(_) {};

  var captureHandler = function captureHandler(handler) {
    return errorHandler = handler;
  };

  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.send(data);

  xhr.onload = function () {
    return;
  };

  xhr.addEventListener("error", function (error) {
    return errorHandler(error);
  });
  return {
    "catch": captureHandler
  };
}

function postData(url, body) {
  fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  }).then(function (response) {})["catch"](function (error) {
    return console.error("Unable to log message: ".concat(url, ", received ").concat(error));
  });
}